// const host = "http://localhost:5000/harrisongroup/us-central1/adminapp"
//https://us-central1-harrisongroup.cloudfunctions.net/adminapp
// const host =
//   "http://localhost:5000/harrison-trial-1597552664148/us-central1/adminapp"
const host = "https://us-central1-harrisongroup.cloudfunctions.net/adminapp"
export default host
